"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemComponent = exports.MenuItemWrapperComponent = void 0;
const mithril_1 = require("../../mithril");
const index_1 = require("../icon/index");
const theme_1 = require("../theme");
const menu_item_style_1 = require("./menu.item.style");
(0, theme_1.addStyles)(menu_item_style_1.Style);
exports.MenuItemWrapperComponent = {
    view(menu, item, selected) {
        let onclick = undefined;
        if (!item.disabled && item.action != null) {
            onclick = () => {
                var _a;
                menu.hide();
                (_a = item.action) === null || _a === void 0 ? void 0 : _a.call(item);
            };
        }
        return (0, mithril_1.m)('div', {
            className: `${menu_item_style_1.CSS.item} ${item.visible === false ? menu_item_style_1.CSS.hidden : ''} ${selected ? menu_item_style_1.CSS.selected : ''} ${item.disabled ? menu_item_style_1.CSS.disabled : ''}`,
            onmouseenter: () => menu.selectItem(item),
            onclick,
            id: item.id,
        }, item.view);
    },
};
exports.MenuItemComponent = {
    view(text, icon) {
        const items = [];
        if (icon) {
            items.push(index_1.Icon.view(icon));
        }
        if (Array.isArray(text)) {
            items.push(...text);
        }
        else {
            items.push(text);
        }
        return mithril_1.m.fragment({}, items);
    },
};
//# sourceMappingURL=menu.item.js.map